import { SIREN_REGEX } from "../validation/regex";
import Yup from "../validation/yup";
const VERSION = 2;
// export interface IEstablishment {
//     version:string;
//     slug: string;
//     id?: string;
//     name: string;
//     type: EstablishmentTypeEnum;
//     logo?: string;
//     description: string;
//     website?: string;
// }
export class EstablishmentFormModel {
    constructor() {
        this.name = '';
        this.type = '';
        this.logo = '';
        this.description = '';
        this.website = '';
        this.contactEmail = '';
        this.siren = '';
        this.knowFrom = '';
    }
    static get validationSchema() {
        return Yup.object({
            contactEmail: Yup.string().lowercase().email().required(),
            name: Yup.string().max(255).trim().required(),
            type: Yup.string().trim().required(),
            logo: Yup.string(),
            description: Yup.string().max(1000).trim().required(),
            website: Yup.string().url(),
            siren: Yup.string().min(9).max(9).matches(SIREN_REGEX, () => ({ key: 'common:formValidation.sirenFormat' })).required()
        });
    }
}
EstablishmentFormModel.VERSION = VERSION;
export class EstablishmentEmbeddedModel {
    constructor(source) {
        this.name = source.name;
        this.type = source.type;
        this.logo = source.logo;
        this.description = source.description;
        this.website = source.website;
        this.contactEmail = source.contactEmail;
        this.siren = source.siren;
    }
}
export class EstablishmentDBModel {
    // location: Location
    constructor(establishmentId, slug, source) {
        this.establishmentId = establishmentId;
        this.slug = slug;
        this.name = source.name;
        this.type = source.type;
        this.logo = source.logo;
        this.description = source.description;
        this.website = source.website;
        this.contactEmail = source.contactEmail;
        this.siren = source.siren;
    }
}
EstablishmentDBModel.VERSION = VERSION;
export class EstablishmentElasticSearchModel {
    constructor(source) {
        this.name = source.name;
        this.type = source.type;
        this.description = source.description;
        this.website = source.website;
    }
}
/** Class for public exposure */
export class EstablishmentViewModel {
    constructor(source) {
        this.name = source.name;
        this.type = source.type;
        this.logo = source.logo;
        this.description = source.description;
        this.website = source.website;
        this.siren = source.siren;
    }
}
export default {
    EstablishmentFormModel,
    EstablishmentEmbeddedModel,
    EstablishmentDBModel,
    EstablishmentElasticSearchModel
};
